import AbstractService from 'core/abstracts/AbstractService';
import Facade from 'core/Facade';

class ControlTowerService extends AbstractService {

    getData(params) {
        const query = `?ps=${params.rowsPerPage}&p=${params.page}${params.selectedSite ? `&sites=${params.selectedSite}` : ''}${params.selectedAccount ? `&accounts=${params.selectedAccount}` : ''}&pending_only=${params.pendingOnly}`;

        return this.request({
            method: 'GET',
            url: Facade.getApiRoot() + 'bo/control-tower/sources/' + params.bot + '/status/' + params.category + '/items' + query,
        }).then(async (responseData) => {
            if (responseData.ok) {
                return {
                    count: responseData.headers.get('X-Total-Count'),
                    sites: await responseData.json()
                };
            }
            throw await responseData.json();
        });
    }

    getStats(params) {
        const query = `?${params.selectedSite ? `&sites=${params.selectedSite}` : ''}${params.selectedAccount ? `&accounts=${params.selectedAccount}` : ''}&pending_only=${params.pendingOnly}`;

        return this.request({
            method: 'GET',
            url: Facade.getApiRoot() + 'bo/control-tower/sources/' + params.bot + '/stats' + query,
        }).then(async (responseData) => {
            if (responseData.ok) {
                return await responseData.json();
            }
            throw await responseData.json();
        });
    }

    changeAction(action, ids, bot, status, params) {
        return this.request({
            method: 'PUT',
            url: Facade.getApiRoot() + `bo/control-tower/sources/${bot}/status/${status}/items`,
            json: {
                ids,
                action,
                params
            }
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }
}

export default new ControlTowerService();
